<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "DocumentPhotoIndex",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  